import { QueryFunctionContext, useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { ActionItemSummaryDto, FetchError, queryKeys, useAccessToken } from "src/http";

const useGetPlanSubitemsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getPlanSubitemsRequest({
    pageParam: actionItemGuid,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.plans.getPlanSubitems>, string>): Promise<
    ActionItemSummaryDto[]
  > {
    // If this is the first "page" just return an empty array.
    if (actionItemGuid === undefined) {
      return [];
    }

    const accessToken = await getAccessToken();
    const response = await fetch(`${configuration.apiRootUrl}/action-items/${actionItemGuid}/subitems`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getPlanSubitemsRequest };
};

const useGetPlanSubitems = (planGuid: string | undefined) => {
  const { getPlanSubitemsRequest } = useGetPlanSubitemsRequest();
  const queryClient = useQueryClient();

  return useInfiniteQuery({
    queryKey: queryKeys.plans.getPlanSubitems(planGuid),
    queryFn: getPlanSubitemsRequest,
    enabled: planGuid !== undefined,
    onSuccess: (data) => {
      data.pages.forEach((page) =>
        page.forEach((actionItem) =>
          queryClient.setQueryData(queryKeys.actionItems.getActionItemSummary(actionItem.guid), actionItem)
        )
      );
    },
  });
};

export { useGetPlanSubitems };
